import { Injectable } from '@angular/core';

let moment = require('moment');

@Injectable()
export class PidTableService {

    pidtypemap = {
        'flat': 'flat',
        'house': 'home',
        'kantoor': 'kantoor',
        'industrie': 'industrie',
        'appartementsgebouw': 'flat',
        'office': 'kantoor',
        'building': 'flat',
        'flatbuilding': 'flat',
        'multifunctional': 'flat'
    }

    type2imgfn(rowtype) {
        let rtype = this.pidtypemap[rowtype.toLowerCase()];
        //console.log(rowtype, rtype, `../../assets/Nestas_room_${rtype}.png`);
        if (rtype) {
            return `../../assets/Nestas_room_${rtype}.png`;
        }
        return '';
    }

    transferInfo(pid) {
        if (!pid) return '';
        let info = '';
        let c = 0;
        for (let index in pid.transferTo.details) {

            let c = +index;
            let d = pid.transferTo.details[c];

            //console.log("pid d.PID", pid, d.PID);
            if (pid?._id != d?.PID) {
                if (c < 2) {
                    info += d.email + ' en ';
                } else if (c == 2) {
                    info += (pid.transferTo.details.length - 2) + ' andere(n) en ';
                }
            }
        }
        return info.slice(0, -3);
    }

    sharedInfo(pid, user) {
        if (!pid) return '';
        let info = '';
        let c = 0;
        let details = pid.transferTo.details.filter(x => x.email != user.email);
        //console.log(details, pid.transferTo.details);
        for (let index in details) {
            let c = +index;
            let d = details[c];
            if (c < 2) {
                info += d.email + ' en ';
            } else if (c == 2) {
                info += (details.length - 2) + ' andere(n) en ';
            }
        }
        return info.slice(0, -3);
    }

    constructor() { }
}